<template>
  <div class="mbody">
    <goods-industry-tile :classname="industryInfo.name"></goods-industry-tile>

    <div class="contents">
      <div class="contents-class">
        <div
          class="contents-class-item"
          :class="{ 'class-item-active': id == 1 }"
          @click="goto(1)"
        >
          <img src="/static/icon/top.png" />
          <p>工业机器人零部件</p>
        </div>
        <div
          class="contents-class-item"
          :class="{ 'class-item-active': id == 9 }"
          @click="goto(9)"
        >
          <img src="/static/icon/industry/2.png" />
          <p>电子</p>
        </div>
        <div
          class="contents-class-item"
          :class="{ 'class-item-active': id == 2 }"
          @click="goto(2)"
        >
          <img src="/static/icon/industry/3.png" />
          <p>消费品</p>
        </div>
        <div
          class="contents-class-item"
          :class="{ 'class-item-active': id == 3 }"
          @click="goto(3)"
        >
          <img src="/static/icon/industry/4.png" />
          <p>商业智能服务</p>
        </div>
        <div
          class="contents-class-item"
          :class="{ 'class-item-active': id == 4 }"
          @click="goto(4)"
        >
          <img src="/static/icon/industry/5.png" />
          <p>仓储物流</p>
        </div>
        <div
          class="contents-class-item"
          :class="{ 'class-item-active': id == 5 }"
          @click="goto(5)"
        >
          <img src="/static/icon/industry/6.png" />
          <p>食品</p>
        </div>
        <div
          class="contents-class-item"
          :class="{ 'class-item-active': id == 6 }"
          @click="goto(6)"
        >
          <img src="/static/icon/industry/7.png" />
          <p>医药</p>
        </div>
        <div
          class="contents-class-item"
          :class="{ 'class-item-active': id == 7 }"
          @click="goto(7)"
        >
          <img src="/static/icon/industry/8.png" />
          <p>汽车及零部件</p>
        </div>
        <div
          class="contents-class-item"
          :class="{ 'class-item-active': id == 8 }"
          @click="goto(8)"
        >
          <img src="/static/icon/industry/9.png" />
          <p>机械设备</p>
        </div>
        <div
          class="contents-class-item"
          :class="{ 'class-item-active': id == 10 }"
          @click="goto(10)"
        >
          <img src="/static/icon/industry/10.png" />
          <p>原材料加工</p>
        </div>
        <div
          class="contents-class-item"
          :class="{ 'class-item-active': id == 11 }"
          @click="goto(11)"
        >
          <img src="/static/icon/industry/11.png" />
          <p>新能源</p>
        </div>
      </div>

      <industry-title
        :title="industryInfo.title"
        :info="industryInfo.subtitle"
      ></industry-title>

      <div class="industry-subinfo">
        {{ industryInfo.subinfo }}
      </div>
    </div>
    <div class="industry-class-list">
      <div
        class="contents industry-class-list-contents"
        v-if="
          industryInfo &&
          industryInfo.classList &&
          industryInfo.classList[0] &&
          industryInfo.classList[0].name != ''
        "
      >
        <!-- <div
          class="class-list-item"
          v-for="(industry, index) in industryInfo.classList"
          :key="index"
          @click="goClass(index)"
        >
          <div
            class="list-item-left"
            :class="{ 'class-list-item-active-left-img': index == onClassId }"
          ></div>
          <div
            class="list-item-mid"
            :class="{ 'class-list-item-active': index == onClassId }"
          >
            {{ industry.name }}
          </div>
          <div
            class="list-item-right"
            :class="{ 'class-list-item-active-img': index == onClassId }"
          ></div>
        </div> -->

        <div
          class="class-list-item-new"
          v-for="(industry, index) in industryInfo.classList"
          :key="index"
          @click="goClass(index)"
          :class="{ 'list-item-new-active': index == onClassId }"
        >
          <div
            class="list-item-new"
          >
            {{ industry.name }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="industry-list-box"
      v-if="
        resetSwiper&&
        industryInfo.classList &&
        industryInfo.classList[onClassId] &&
        industryInfo.classList[onClassId].list &&
        industryInfo.classList[onClassId].list[0] &&
        industryInfo.classList[onClassId].list[0].title != ''
      "
    >
      <div
        class="industry-list"
        v-for="(info, iIndex) in industryInfo.classList[onClassId].list"
        :key="'info' + iIndex"
      >
        <industry-list :info="info"></industry-list>
      </div>
    </div>

    <industry-goods-list
      v-if="resetSwiper && industryInfo.classList"
      :classInfo="industryInfo.classList[onClassId]"
    ></industry-goods-list>

    <industry-from></industry-from>
  </div>
</template>
    
<script>
import { Message } from "element-ui";
import { mapGetters } from "vuex";
import GoodsIndustryTile from "../../components/goods/GoodsIndustryTile.vue";
import IndustryList from "../../components/industry/IndustryList.vue";
import IndustryTitle from "../../components/industry/IndustryTitle.vue";
import IndustryFrom from "../../components/industry/IndustryFrom.vue";
import Toactivate from "../user/toactivate.vue";
import IndustryGoodsList from "../../components/industry/IndustryGoodsList.vue";
export default {
  data() {
    return {
      id: 1,
      industryInfo: "",
      onClassId: 0,
      resetSwiper: true,
      metainfo: {},
    };
  },
  components: {
    GoodsIndustryTile,
    IndustryList,
    IndustryTitle,
    IndustryFrom,
    Toactivate,
    IndustryGoodsList,
  },
  methods: {
    //seo信息
    getMetaInfo(id) {
      this.metainfo = this.$api.industry.getmetaInfo(id);
    },
    //获取行业基本信息
    getIndustryInfo(id) {
      this.industryInfo = this.$api.industry.getIndustryInfo(id);
      if (this.industryInfo.classList) {
        this.onClassId = this.industryInfo.classList.length - 1;
      }
    },
    goClass(val) {
      this.onClassId = val;
      this.resetSwiper = false;
      this.$nextTick(function () {
        this.resetSwiper = true;
      });
    },
    goto(val) {
      this.$router.push({ name: "industryinfo", params: { id: val } });
    },
    
  },
  metaInfo() {
    return {
      title: this.metainfo.title,
      meta: [
        { name: "keywords", content: this.metainfo.keywords },
        { name: "description", content: this.metainfo.description },
      ],
    };
  },
  watch: {
    $route(to, from) {
      //监听URL地址栏参数变化
      this.id = this.$route.params.id;
      this.resetSwiper = false;
      this.getMetaInfo(this.id);
      this.getIndustryInfo(this.id);
      this.$nextTick(function () {
        this.resetSwiper = true;
      });
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getMetaInfo(this.id);
    this.getIndustryInfo(this.id);
  },
};
</script>

<style  scoped>
.contents-class {
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
  margin-top: 26px;
}

.contents-class-item {
  cursor: pointer;
  width: 100px;
  height: 130px;
  background: #ffffff;
  margin-top: 5px;
  margin-bottom: 5px;
}
.contents-class-item img {
  margin-top: 20px;
  margin-bottom: 13px;
}
.contents-class-item p {
  margin: 0 auto;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  width: 78px;
  letter-spacing: 1.5px;
  color: #333333;
}

.class-item-active,
.contents-class-item:hover {
  box-shadow: 0px 0px 3px 1px rgba(38, 85, 174, 0.15);
  border-radius: 5px;
}
.class-item-active img,
.contents-class-item:hover img {
  color: #2655ae;
}
.class-item-active p,
.contents-class-item:hover p {
  color: #2655ae;
}
/**title  industry-title */

.industry-subinfo {
  margin: 0 auto;
  width: 645px;
  text-align: center;
  font-size: 16px;
  line-height: 21px;
  color: #999999;
  letter-spacing: 2px;
  margin-top: 10px;
  margin-bottom: 60px;
}
/**导航 */
.industry-class-list {
  width: 100%;
  height: 40px;
  padding-top: 5px;
  border-bottom: 1px solid #2655ae;
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
}
.industry-class-list .class-list-item {
  height: 40px;
  margin-left: -22px;
  display: inline-block;
  cursor: pointer;
}
/* .list-item-left {
  width: 15px;
  height: 40px;
  background-color: #f2f2f2;
  border-top-left-radius: 15px;
  float: left;
  box-shadow: 3px 0px 3px rgba(0, 0, 0, 0.25);
} */
.list-item-left {
  float: left;
  width: 34px;
  height: 40px;
  background: url(/static/icon/class-list-left.png) no-repeat 100% 100%;
}
.list-item-mid {
  float: left;
  background-color: #f2f2f2;
  height: 40px;
  line-height: 40px;
  box-shadow: 5px 0px 5px rgba(0, 0, 0, 0.25);
  padding-right: 5px;
}
.list-item-right {
  float: left;
  width: 34px;
  height: 40px;
  background: url(/static/icon/class-list-right.png) no-repeat 100% 100%;
}
.industry-class-list-contents {
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
}
.class-list-item-active {
  background-color: #2655ad;
  color: #ffffff;
}
.class-list-item-active-img {
  background: url(/static/icon/class-list-right-active.png) no-repeat 100% 100%;
}
.class-list-item-active-left-img{
 background: url(/static/icon/class-list-left-active.png) no-repeat 100% 100%;
}
.industry-list {
  margin-top: 80px;
}
.industry-list-box {
  overflow: hidden;
  background-color: #f3f5f7;
}



.class-list-item-new {
  background: url(/static/icon/bj2.png) no-repeat;
  background-size: 100% 100%;
  width: 184px;
  height: 40px;
  line-height: 40px;
  margin-left: -40px;
  cursor:pointer;
}
.list-item-new-active{
  background: url(/static/icon/bj1.png) no-repeat;
  background-size: 100% 100%;
  color: #fff;
}
.list-item-new{
  text-align: center;
  height: 36px;
  line-height: 36px;
  margin-top: 4px;
}
</style>


// WEBPACK FOOTER //
// src/views/industry/index.vue